import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-12 overview-item listed-search-article" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = { class: "card-title-heading" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 col-md-9" }
const _hoisted_11 = { class: "col-12 col-md-3 text-right" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "breadcrumb mb-0 pb-0"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "link card-link",
        href: _ctx.url || '#',
        target: "_self",
        role: "navigation"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString((_ctx.item && _ctx.item['page_title_s']) || 'Kein Titel'), 1),
                    _createElementVNode("span", _hoisted_11, [
                      (_ctx.badges)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.badges, (badge, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: _normalizeClass(`badge border border-dark text-dark${(parseInt(index) > 0) ? ' ml-1' : ''}`)
                            }, _toDisplayString(badge), 3))
                          }), 128))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (_ctx.highlight)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    innerHTML: _ctx.sanitizeHtml(`… ${_ctx.highlight} …`),
                    class: "card-text"
                  }, null, 8, _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 8, _hoisted_3),
      (_ctx.ancestors && _ctx.ancestors.length > 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.ancestors || []), (ancItem, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("a", {
                  href: _ctx.sanitizeUrl(ancItem.link || '#')
                }, _toDisplayString(ancItem.title || 'Kein Titel'), 9, _hoisted_14),
                ((index + 1) < _ctx.ancestors.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, " / "))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: "badge",
      "aria-hidden": "true"
    }, null, -1))
  ]))
}